import { render, staticRenderFns } from "./MaintenanceTable.vue?vue&type=template&id=2f4a3b5c"
import script from "./MaintenanceTable.vue?vue&type=script&lang=js"
export * from "./MaintenanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports